import { InquiryButtonLink as ButtonLink } from "./inquiry-origin.js";
import type { ReactNode } from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router";
import { Eyebrow } from "@zylarity/ui";
import "./interior-redesign.css";

export function InteriorSection({
  children,
  tint = false,
  className = "",
  id,
}: {
  children: ReactNode;
  tint?: boolean;
  className?: string;
  id?: string;
}) {
  return (
    <section
      id={id}
      className={`interior-section ${tint ? "interior-section--tint" : ""} ${className}`}
    >
      <div className="public-shell">
        {tint ? <div className="interior-panel">{children}</div> : children}
      </div>
    </section>
  );
}
export function InteriorLink({ href, children }: { href: string; children: ReactNode }) {
  return (
    <Link className="text-link" to={href}>
      {children}
      <ArrowRight size={16} aria-hidden="true" />
    </Link>
  );
}
export function ServiceResource({
  title,
  copy,
  href,
  action,
  children,
}: {
  title: string;
  copy: string;
  href: string;
  action: string;
  children?: ReactNode;
}) {
  return (
    <section className="public-shell service-resource" aria-label="Related reading">
      <div className="service-resource__card">
        <div>
          <Eyebrow>Before your next conversation</Eyebrow>
          <h2>{title}</h2>
          <p>{copy}</p>
        </div>
        <div className="service-resource__actions">
          <InteriorLink href={href}>{action}</InteriorLink>
          {children}
        </div>
      </div>
    </section>
  );
}
export function InteriorClosing({
  eyebrow,
  title,
  children,
  href,
  button,
}: {
  eyebrow?: string;
  title: string;
  children?: ReactNode;
  href?: string;
  button?: string;
}) {
  return (
    <InteriorSection className="interior-closing">
      {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
      <h2>{title}</h2>
      {children}
      {href && button && (
        <div className="interior-actions">
          <ButtonLink href={href}>{button}</ButtonLink>
        </div>
      )}
    </InteriorSection>
  );
}
